var map = {
	"./ar": 4785,
	"./ar.ts": 4785,
	"./bn": 55487,
	"./bn.ts": 55487,
	"./en": 78931,
	"./en.ts": 78931,
	"./fa": 83269,
	"./fa.ts": 83269,
	"./fr": 11405,
	"./fr.ts": 11405,
	"./id": 64362,
	"./id.ts": 64362,
	"./it": 75012,
	"./it.ts": 75012,
	"./ms": 8410,
	"./ms.ts": 8410,
	"./nl": 78610,
	"./nl.ts": 78610,
	"./pt": 97425,
	"./pt.ts": 97425,
	"./ru": 2824,
	"./ru.ts": 2824,
	"./sq": 38343,
	"./sq.ts": 38343,
	"./th": 60297,
	"./th.ts": 60297,
	"./tr": 41437,
	"./tr.ts": 41437,
	"./ur": 69289,
	"./ur.ts": 69289,
	"./zh": 43156,
	"./zh.ts": 43156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70301;